module.exports = __webpack_public_path__ + "img/39_51.af0824e2.png";